"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderSide = void 0;
var OrderSide;
(function (OrderSide) {
    OrderSide["Exchange"] = "exchange";
    OrderSide["Target"] = "target";
})(OrderSide = exports.OrderSide || (exports.OrderSide = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3JkZXJTaWRlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2V4Y2hhbmdlL09yZGVyU2lkZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxJQUFZLFNBR1g7QUFIRCxXQUFZLFNBQVM7SUFDbkIsa0NBQXFCLENBQUE7SUFDckIsOEJBQWlCLENBQUE7QUFDbkIsQ0FBQyxFQUhXLFNBQVMsR0FBVCxpQkFBUyxLQUFULGlCQUFTLFFBR3BCIn0=